module.exports = __webpack_public_path__ + "img/antes_despues_230.47932c20.png";